/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { checkPhoneFromDeviceResponseSchema } from "./checkPhoneFromDeviceResponseSchema.ts";
import { errorResponseSchema } from "./errorResponseSchema.ts";

export const deviceAuthCheckPhoneRetrieveQueryCountryCodeSchema = z.string().min(1).max(4).optional().default("+7");

export const deviceAuthCheckPhoneRetrieveQueryPhoneSchema = z.string().min(1).max(11);

export const deviceAuthCheckPhoneRetrieveStatus200Schema = checkPhoneFromDeviceResponseSchema.describe(
	"Сериализатор ответа проверки номера телефона на киоске.",
);

export const deviceAuthCheckPhoneRetrieveStatus400Schema = errorResponseSchema;

export const deviceAuthCheckPhoneRetrieveStatus404Schema = errorResponseSchema;

export const deviceAuthCheckPhoneRetrieveStatus503Schema = errorResponseSchema;

export const deviceAuthCheckPhoneRetrieveResponseSchema = z.union([
	deviceAuthCheckPhoneRetrieveStatus200Schema,
	deviceAuthCheckPhoneRetrieveStatus400Schema,
	deviceAuthCheckPhoneRetrieveStatus404Schema,
	deviceAuthCheckPhoneRetrieveStatus503Schema,
]);
